import {call, put, select, takeEvery} from "redux-saga/effects";
import { 
    FETCH_SINGLE_DAILY_INSIGHTS_IMAGE, 
    FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED, 
    FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_SUCCESSFULLY, 
    GET_PATIENT_INFORMATION_DAILY_INSIGHTS, 
    PatientInformationDailyInsightsCachingActions, 
    PatientInformationDailyInsightsIndexActions, 
    PatientInformationDailyInsightsNavigationActions
} from "./patient-information-daily-insights.actions";
import {GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED, GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY} from "./patient-information-daily-insights.actions";
import { DailyInsightsApiService } from "modules/doctor-dashboard/patients/patient-information/patient-insights-api/patient-insights-api.service";
import { PATIENT_INSIGHTS_BATCH_SIZE } from "appConstants";
import { PatientInformationDailyInsightsSelectors } from "./patient-information-daily-insights.selectors";
import { CachedInsightImage, InsightImageStatus } from "../patient-information-daily-insights.interface";
import { InsightImage } from "doctors-dashboard";

async function downloadImageData(url: string): Promise<Blob> {
    const result = await fetch(url);
    if (!result.ok) throw new Error('Unable to download image data. Check your internet connection.');
    return result.blob();
}

function* getPatientInformationDailyInsightsSaga(action: any): Generator<any, any, any> {
    try {

        const apiService = DailyInsightsApiService.getInstance();
        if (!apiService) {
            throw new Error("Failed to initialize Daily Insights API service");
        }

        const patient = yield select(PatientInformationDailyInsightsSelectors.patient);
        const quantity = action.payload.quantity ? action.payload.quantity : PATIENT_INSIGHTS_BATCH_SIZE
        const response: InsightImage[] = yield call([apiService, apiService.getPatientInsights], patient.patientId, action.payload.date, quantity, true);

        if (!response) {
            throw new Error("No response received from Daily Insights API");
        }
        const transformedResponse: CachedInsightImage[] = response.filter((insight) => insight.url && insight.date).map((insight) => {
            const transformedInsight: CachedInsightImage = {
                url: insight.url!,
                date: insight.date!,
                status: InsightImageStatus.LOADING,
                blobUrl: undefined,

            }
            return transformedInsight;
        });
        yield put(GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY(transformedResponse));
    } catch (error) {
        // yield put(ENQUEUE_SNACKBAR(getNotifierModel(ERROR_TEXT, 'GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED')))
        yield put(GET_PATIENT_INFORMATION_DAILY_INSIGHTS_FAILED(error as Error));
    }
}

function* navigateToPrevious(action: any): Generator<any, any, any> {
    const currentImageIndex = yield select(PatientInformationDailyInsightsSelectors.currentImageIndex)
    const loadedImages = yield select(PatientInformationDailyInsightsSelectors.loadedImages)
    const additionalInsightsAvailable = yield select(PatientInformationDailyInsightsSelectors.additionalInsightsAvailable)
    const loading = yield select(PatientInformationDailyInsightsSelectors.loading)

    if (currentImageIndex === loadedImages.length - 1 && additionalInsightsAvailable && !loading) {
        const date = new Date(`${loadedImages[currentImageIndex].date}T02:00:00Z`);
        date.setUTCDate(date.getUTCDate() - 1);
        const finalDate = date.toISOString().slice(0, 10);
        yield put(GET_PATIENT_INFORMATION_DAILY_INSIGHTS(finalDate))
    }
}

function* fetchAllDailyInsightsImages(action: any): Generator<any, any, any> {
    const insights: CachedInsightImage[] = action.payload;

    for (const insight of insights) {
            yield put(FETCH_SINGLE_DAILY_INSIGHTS_IMAGE(insight));
    }}

function* fetchSingleDailyInsightsImage(action: any): Generator<any, any, any> {
    try {
        const blob = yield call(downloadImageData, action.payload.url);
        const objectUrl = URL.createObjectURL(blob);

        yield put(FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_SUCCESSFULLY(action.payload.date, objectUrl));
    } catch (error) {
        // yield put(ENQUEUE_SNACKBAR(getNotifierModel(ERROR_TEXT_SINGLE_IMAGE, 'FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED')));
        yield put(FETCH_SINGLE_DAILY_INSIGHTS_IMAGE_FAILED(action.payload.date, error as Error));
    }
}

function* reloadCurrentInsightsImage(action: any): Generator<any, any, any> {
    const currentImage: CachedInsightImage = yield select(PatientInformationDailyInsightsSelectors.currentImage);
    const currentDate = currentImage.date;
    yield put(GET_PATIENT_INFORMATION_DAILY_INSIGHTS(currentDate, 1));
}

export function* patientInformationDailyInsightsSaga() {
    yield takeEvery(PatientInformationDailyInsightsNavigationActions.NAVIGATE_TO_DAILY_INSIGHTS_PREVIOUS, navigateToPrevious);
    yield takeEvery(PatientInformationDailyInsightsIndexActions.GET_PATIENT_INFORMATION_DAILY_INSIGHTS, getPatientInformationDailyInsightsSaga);
    yield takeEvery(PatientInformationDailyInsightsIndexActions.GET_PATIENT_INFORMATION_DAILY_INSIGHTS_SUCCESSFULLY, fetchAllDailyInsightsImages);
    yield takeEvery(PatientInformationDailyInsightsCachingActions.FETCH_SINGLE_DAILY_INSIGHTS_IMAGE, fetchSingleDailyInsightsImage);
    yield takeEvery(PatientInformationDailyInsightsCachingActions.RELOAD_CURRENT_INSIGHT_IMAGE, reloadCurrentInsightsImage);
} 